import {ActionIcon, Affix, Tooltip} from '@mantine/core';
import * as React from 'react';
import {useState} from 'react';
import {IconLink} from "@tabler/icons-react";
import {useContextMenu} from "mantine-contextmenu";

export const LinkCopyButtonComponent= ({link , section, variant = "transparent"}: {
    link: string,
    section?: string,
    variant?: "transparent"|"default"
}) => {
    const [opened, setOpened] = useState(false);
    const {showContextMenu} = useContextMenu();

    const menuItems = () => [
        {
            key: 'base',
            title: 'Copy Base URL',
            onClick: () => {
                navigator.clipboard.writeText(link).then()
                setOpened(true)
                setTimeout(() => {
                    setOpened(false)
                }, 1000)
            }
        },
        {
            key: 'with_section',
            title: 'Copy With Section',
            onClick: () => {
                navigator.clipboard.writeText(link + `&section=${section}`).then()
                setOpened(true)
                setTimeout(() => {
                    setOpened(false)
                }, 1000)
            }
        }
    ]

    return (
        <Tooltip label={"Link copied to Keyboard"} opened={opened} withArrow arrowOffset={10} arrowSize={4}>
            <ActionIcon
                onClick={(e) => {
                    if (section) {
                        showContextMenu(menuItems())(e)
                    } else {
                        navigator.clipboard.writeText(link).then()
                        setOpened(true)
                        setTimeout(() => {
                            setOpened(false)
                        }, 1000)
                    }
                }}
                variant={variant}
                color={"var(--mantine-color-base-button)"}
            >
                <IconLink/>
            </ActionIcon>
        </Tooltip>
    );
};